/* eslint-disable @typescript-eslint/no-explicit-any */
import { advanceRuleEngineTypes } from '../reduxExports';
import { AdvanceRuleEngineAction } from './advanceRuleEngineType';
import hwaxios from '../api-service/HWAxios';
import { isAxiosError } from 'axios';
import rmsStore from '../rmsStore';
import { isEqual } from 'lodash';
import { IDerivedCondition } from '../../components/advanceRuleEngine/executionPlan/DerivedConditionPlan';


const url = process.env.REACT_APP_SERVER_BASE_URL;


export const advanceRuleEngineCreateRule: any =  async (reqBody: any) => {
  try {
    const { data, status } = await hwaxios.post(url + '/rule-engine', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: {message: 'Something went wrong'}, status: 400
      };
    }
  }
}
export const advanceRuleEngineUpdateRule: any =  async (reqBody: any) => {
  try {
    const { data, status } = await hwaxios.put(url + '/rule-engine', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: {message: 'Something went wrong'}, status: 400
      };
    }
  }
}

export const setAdvanceRuleEngineFormRedux: any = (data) => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_FORM_REDUX,
    advanceRuleEngineFormRedux: data,
  };
  dispatch(action);
}


export const clearAdvanceRuleEngineFormRedux: any = () => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.CLEAR_ADVANCE_RULE_ENGINE_FORM_REDUX,
    advanceRuleEngineFormRedux: null,
  };
  dispatch(action);
}


export const fetchAdvanceRuleEngineRuleListData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AdvanceRuleEngineAction> =  {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
      advanceRuleEngineListLoader: true
    }
    dispatch(loaderStartAction);

    const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
      ? reqBody.searchTerm.trim() : null;

    const filterHash = reqBody?.filters;

    const hashAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_REQUEST_HASH,
      advanceRuleEngineSearchHash: searchHash,
      advanceRuleEngineFilterHash: filterHash
    }
    dispatch(hashAction);


    const response = await hwaxios.post(url + '/rule-engine/list', reqBody)
    if (
      searchHash === rmsStore.getState().advanceRuleEngineReducer.advanceRuleEngineSearchHash &&
      isEqual(filterHash, rmsStore.getState().advanceRuleEngineReducer.advanceRuleEngineFilterHash)
    ) {
      const action = {
        type: advanceRuleEngineTypes.FETCH_ADVANCE_RULE_ENGINE_RULE_LIST,
        advanceRuleEngineRuleList: response.data?.data?.response,
        advanceRuleEngineListCount: response.data?.data?.count,
      };
      dispatch(action);
    }

    if (response?.status === 200) {
      const loaderEndAction: Partial<AdvanceRuleEngineAction> = {
        type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
        advanceRuleEngineListLoader: false
      }
      dispatch(loaderEndAction);
    }

  } catch(error) {
    const loaderEndAction: Partial<AdvanceRuleEngineAction> =  {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
      advanceRuleEngineListLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
}


export const fetchAdvanceRuleEngineRuleHistoryListData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AdvanceRuleEngineAction> =  {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
      advanceRuleEngineListLoader: true
    }
    dispatch(loaderStartAction);

    const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
      ? reqBody.searchTerm.trim() : null;

    const filterHash = reqBody?.filters;

    const hashAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY_REQUEST_HASH,
      advanceRuleEngineHistoryListSearchHash: searchHash,
      advanceRuleEngineHistoryListFilterHash: filterHash
    }
    dispatch(hashAction);


    const response = await hwaxios.post(url + '/rule-engine/history', reqBody)
    if (
      searchHash === rmsStore.getState().advanceRuleEngineReducer.advanceRuleEngineHistoryListSearchHash &&
      isEqual(filterHash, rmsStore.getState().advanceRuleEngineReducer.advanceRuleEngineHistoryListFilterHash)
    ) {
      const action: Partial<AdvanceRuleEngineAction> = {
        type: advanceRuleEngineTypes.FETCH_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY,
        advanceRuleEngineRuleHistoryList: response.data?.data?.response,
        advanceRuleEngineHistoryListCount: response.data?.data?.count,
      };
      dispatch(action);
    }

    if (response?.status === 200) {
      const loaderEndAction: Partial<AdvanceRuleEngineAction> = {
        type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
        advanceRuleEngineListLoader: false
      }
      dispatch(loaderEndAction);
    }

  } catch(error) {
    const loaderEndAction: Partial<AdvanceRuleEngineAction> =  {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
      advanceRuleEngineListLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
}

export const setAdvanceRuleEngineListTableProps: any = (data) => (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void ): void => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_TABLE_PROPS,
    advanceRuleEngineListTableProps: data
  }
  dispatch(action);
}

export const setAdvanceRuleEngineHistoryListTableProps: any = (data) => (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void ): void => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_HISTORY_TABLE_PROPS,
    advanceRuleEngineHistoryListTableProps: data
  }
  dispatch(action);
}

export const exportAdvanceRuleEngineHistoryData: any = (reqBody) => async (): Promise<unknown> => {
  try {
    const { data, status } = await hwaxios.post(url + '/rule-engine/history/export', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: {message: 'Something went wrong'}, status: 400
      };
    }
  }
}


export const toggleAdvanceRuleEngineRuleStatus: any = (reqBody) => async () : Promise<unknown> => {
  try {
    const { data, status } = await hwaxios.post(url + '/rule-engine/status',reqBody);
    return { data, status };
  } catch (error) {
    if(isAxiosError(error)) {
      if(error.response){
        const data = error.response.data;
        const status = error.response.status;
        return {data,status};
      }
    } else {
      return { data: {message: 'Something went wrong'}, status: 400 }
    }
  }
}


export const fetchAdvanceRuleEngineRule: any = (reqParam) => async () : Promise<any> => {
  try {
    // if(reqParam?.id === rmsStore.getState().advanceRuleEngineReducer?.advanceRuleEngineFormRedux?.id) {
    //   return rmsStore.getState().advanceRuleEngineReducer?.advanceRuleEngineFormRedux;
    // }
    const res = await hwaxios.get(url + '/rule-engine',{params: reqParam});
    const rule = res?.data?.data;
    const conditions = rule?.conditions?.map(condition => {
      return {
        ...condition,
        errorMessage:  null,
        errorMessageSecondary: null,
        errorMessageArithmeticParam: null
      }
    })
    const executionPlan = {
      triggerType: rule?.occurrenceLogic === 'Scheduled' ? 'scheduler' : 'parameter',
      trigger: {
        conditions: conditions ?? [],
        expression: rule?.expression,
        occurrenceLogic: rule?.occurrenceLogic === 'Scheduled' ? 'basic' : rule?.occurrenceLogic?.toLowerCase() ,
        numberOfOccurrences: rule?.numberOfOccurrences,
        timePeriod: rule?.timePeriod,
        timeUnit: rule?.timeUnit,
        isConsecutive: rule?.isConsecutive,
        waitTimePeriod: rule?.waitTimePeriod,
        waitTimeUnit: rule?.waitTimeUnit
      },
      scheduleTime:{
        scheduleType: rule?.scheduleType,
        dateTime: rule?.scheduleDateTime,
        recurrenceDays: rule?.recurrenceDays,
        recurrenceRange: rule?.recurrenceRange,
        recurrenceCount: rule?.recurrenceCount,
        endDate: rule?.endDate
      },
      actions: rule?.actions ?? [],
      conditionBlocks: rule?.conditionBlocks ?? []
    }
    const ruleFormRedux = {
      id: rule?.id,
      name: rule?.ruleName,
      description: rule?.description,
      chargerIds: rule?.chargerIds,
      status: rule?.status,
      draftStatus: rule?.draftStatus,
      executionPlan: executionPlan,
      autoAssign: rule?.autoAssign ?? 'Disabled',
      imageURL: rule?.fileURL,
      fileName: rule?.fileName,
      runningStatus: rule?.runningStatus,
      executionThreshold: rule?.executionThreshold,
      resetTimePeriod: rule?.resetTimePeriod,
      resetTimeUnit: rule?.resetTimeUnit,
      autoAssignCustomerIds: rule?.autoAssignCustomerIds,
      autoAssignProductTypeIds: rule?.autoAssignProductTypeIds
    } 
    return ruleFormRedux;
  }catch (err) {
    console.error(err);
    throw err;
  }
}


export const setDerivedConditionFormRedux: any = (data) => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.SET_DERIVED_CONDITION_FORM_REDUX,
    derivedConditionFormRedux: data,
  };
  dispatch(action);
}


export const clearDerivedConditionFormRedux: any = () => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.CLEAR_DERIVED_CONDITION_FORM_REDUX,
    derivedConditionFormRedux: null,
  };
  dispatch(action);
}

export const setDerivedConditionsListTableProps: any = (data) => (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void ): void => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.SET_DERIVED_CONDITIONS_LIST_TABLE_PROPS,
    derivedConditionsListTableProps: data
  }
  dispatch(action);
}

export const fetchDerivedConditionsListData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AdvanceRuleEngineAction> =  {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
      advanceRuleEngineListLoader: true
    }
    dispatch(loaderStartAction);

    const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
      ? reqBody.searchTerm.trim() : null;

    const filterHash = reqBody?.filters;

    const hashAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_DERIVED_CONDITIONS_LIST_REQUEST_HASH,
      derivedConditionsSearchHash: searchHash,
      derivedConditionsFilterHash: filterHash
    }
    dispatch(hashAction);

    const response = await hwaxios.post(url + '/rule-engine/derived-condition/list', reqBody);

    if (
      searchHash === rmsStore.getState().advanceRuleEngineReducer.derivedConditionsSearchHash &&
      isEqual(filterHash, rmsStore.getState().advanceRuleEngineReducer.derivedConditionsFilterHash)
    ) {
      const action = {
        type: advanceRuleEngineTypes.FETCH_DERIVED_CONDITIONS_LIST,
        derivedConditionsList: response.data?.data?.response,
        derivedConditionsListCount: response.data?.data?.count,
      };
      dispatch(action);
    }

    if (response?.status === 200) {
      const loaderEndAction: Partial<AdvanceRuleEngineAction> = {
        type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
        advanceRuleEngineListLoader: false
      }
      dispatch(loaderEndAction);
    }

  } catch(error) {
    const loaderEndAction: Partial<AdvanceRuleEngineAction> =  {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_RULE_LIST_LOADER,
      advanceRuleEngineListLoader: false
    }
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
}

export const createDerivedConditon: any =  async (reqBody: any) => {
  try {
    const { data, status } = await hwaxios.post(url + '/rule-engine/derived-condition', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: {message: 'Something went wrong'}, status: 400
      };
    }
  }
}


export const updateDerivedConditon: any =  async (reqBody: any) => {
  try {
    const { data, status } = await hwaxios.put(url + '/rule-engine/derived-condition', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: {message: 'Something went wrong'}, status: 400
      };
    }
  }
}


export const fetchDerivedCondition: any = (reqParam) => async () : Promise<any> => {
    try {
    if(reqParam?.id === rmsStore.getState().advanceRuleEngineReducer?.derivedConditionFormRedux?.id) {
      return rmsStore.getState().advanceRuleEngineReducer?.derivedConditionFormRedux;
    }
    const response = await hwaxios.get(url + '/rule-engine/derived-condition',{params: reqParam});
    const derivedCondition:IDerivedCondition = response?.data?.data;    
    return derivedCondition;
  }catch(error){
    console.error(error);
    throw error
  }
}


export const fetchAdvanceRuleExecutionSummary: any = (reqBody: any) => async(dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_RULE_EXECUTION_SUMMARY_LOADER,
      ruleExecutionSummaryLoader: true
    }
    dispatch(loaderStartAction);

    const filterHash = reqBody?.filters;

    const hashAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_RULE_EXECUTION_SUMMARY_LIST_REQUEST_HASH,
      ruleExecutionSummaryFilterHash: filterHash
    }

    dispatch(hashAction);

    const res = await hwaxios.post(url + '/rule-engine/history', reqBody);

    if(isEqual(filterHash,rmsStore.getState().advanceRuleEngineReducer.ruleExecutionSummaryFilterHash)){
      const action: Partial<AdvanceRuleEngineAction> = {
        type: advanceRuleEngineTypes.FETCH_RULE_EXECUTION_SUMMARY_LIST,
        ruleExecutionSummary: res?.data?.data?.response,
        ruleExecutionSummaryCount: res?.data?.data?.count
      }
      dispatch(action);
    }
  }catch(error){
    console.error(error);
    throw error;
  }finally{
    const loaderEndAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_RULE_EXECUTION_SUMMARY_LOADER,
      ruleExecutionSummaryLoader: false
    }
    dispatch(loaderEndAction);
  }
}

export const setAdvanceRuleExecutionSummaryTableProps: any = (data) => (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void ): void => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.SET_RULE_EXECUTION_SUMMARY_LIST_TABLE_PROPS,
    ruleExecutionSummaryListTableProps: data
  }
  dispatch(action);
}

export const exportRuleExecutionSummary: any = (reqBody) => async (): Promise<unknown> => {
  try {
    const { data, status } = await hwaxios.post(url + '/rule-engine/history/export', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: {message: 'Something went wrong'}, status: 400
      };
    }
  }
}

export const deleteAdvanceRuleEngineRule: any = (id: string) => async (): Promise<any> => {
  try {
    const { data, status } = await hwaxios.delete(url + `/rule-engine?id=${id}`);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: {message: 'Something went wrong'}, status: 400
      };
    }
  }
}


export const setAdvanceRuleEngineLayoutView: any = (data) => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  const action: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_ADVANCE_RULE_ENGINE_LAYOUT_VIEW,
      advanceRuleEngineLayoutView: data
    }
    dispatch(action);
}

export const fetchRuleTriggerLogs: any = (reqBody: any) => async (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_RULE_TRIGGER_LOGS_LOADER,
      ruleTriggerLogsLoader: true
    }
    dispatch(loaderStartAction);

    const filterHash = reqBody?.filters;

    const hashAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_RULE_TRIGGER_LOGS_LIST_REQUEST_HASH,
      ruleTriggerLogsFilterHash: filterHash
    }
    dispatch(hashAction);

    const res = await hwaxios.post(url + '/rule-engine/trigger-logs', reqBody);

    if (isEqual(filterHash, rmsStore.getState().advanceRuleEngineReducer.ruleTriggerLogsFilterHash)) {
      const action: Partial<AdvanceRuleEngineAction> = {
        type: advanceRuleEngineTypes.FETCH_RULE_TRIGGER_LOGS_LIST,
        ruleTriggerLogs: res?.data?.data?.response,
        ruleTriggerLogsCount: res?.data?.data?.count
      }
      dispatch(action);
    }
  } catch (error) {
    console.error(error);
    throw error;
  } finally {
    const loaderEndAction: Partial<AdvanceRuleEngineAction> = {
      type: advanceRuleEngineTypes.SET_RULE_TRIGGER_LOGS_LOADER,
      ruleTriggerLogsLoader: false
    }
    dispatch(loaderEndAction);
  }
}

export const setRuleTriggerLogsTableProps: any = (data) => (dispatch: (arg0: Partial<AdvanceRuleEngineAction>) => void): void => {
  const action: Partial<AdvanceRuleEngineAction> = {
    type: advanceRuleEngineTypes.SET_RULE_TRIGGER_LOGS_LIST_TABLE_PROPS,
    ruleTriggerLogsListTableProps: data
  }
  dispatch(action);
}

export const exportRuleTriggerLogs: any = (reqBody) => async (): Promise<unknown> => {
  try {
    const { data, status } = await hwaxios.post(url + '/rule-engine/trigger-logs/export', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: { message: 'Something went wrong' }, status: 400
      };
    }
  }
}

export const advanceRuleEngineUpdateLogs: any = (id: string) => async () => {
  try {
    const response = await hwaxios.get(url + `/rule-engine/update-logs?id=${id}`)
    if (response?.status === 200 || response?.status === 202) {
      return { status: 'success', data: response?.data?.data }
    }
    else {
      return { status: 'failure' }
    }
  } catch (e) {
    return { status: 'failure' }
  }
}
